import * as React from "react";

import { ConfigurationProps } from "./configuration.types";
import { useConfigurationController } from "./configuration.controller";
import { Template } from "./template";

import "./configuration.styles.scss";

export const Configuration: React.FC<ConfigurationProps> = (props) => {
  const { questionnaire } = props;

  const { handleTemplateChange, configurationTemplates } = useConfigurationController(props);

  return (
    <div className="FhqDesignTool-configuration">
      {configurationTemplates.map((config, configIndex) => (
        <div className="FhqDesignTool-configuration__section" key={configIndex}>
          {config.map((template) => (
            <Template
              key={template.id}
              metadata={{
                description: template.id,
              }}
              label={template.label}
              value={questionnaire.configurationTab[template.id] || ""}
              onChange={handleTemplateChange(template.id)}
            />
          ))}
        </div>
      ))}
    </div>
  );
};
